/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free tip calculator. Enter the bill, tip percentage and number of people to see the tip amount, total and the share per person.`)
};

const es_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de propina gratuita. Introduce la cuenta, el porcentaje de propina y el número de personas para ver el importe de la propina, el total y la parte de cada quien.`)
};

const de_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Trinkgeldrechner. Gib Rechnungsbetrag, Trinkgeld-Prozentsatz und Anzahl der Personen ein, um Trinkgeldbetrag, Gesamtbetrag und den Anteil pro Person zu sehen.`)
};

const nl_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis fooicalculator. Vul de rekening, het fooipercentage en het aantal personen in voor het fooibedrag, het totaal en het aandeel per persoon.`)
};

const fr_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de pourboire gratuit. Entrez l'addition, le pourcentage de pourboire et le nombre de personnes pour voir le montant, le total et la part par personne.`)
};

const it_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore di mance gratuito. Inserisci il conto, la percentuale di mancia e il numero di persone per vedere mancia, totale e quota a persona.`)
};

const pt_br2_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de gorjeta gratuita. Insira a conta, a porcentagem da gorjeta e o número de pessoas para ver o valor da gorjeta, o total e a parte de cada um.`)
};

const pt_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de gorjeta gratuita. Insira a conta, a percentagem de gorjeta e o número de pessoas para ver o valor da gorjeta, o total e a parte de cada pessoa.`)
};

const ja_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のチップ計算機。会計額、チップの割合、人数を入力すると、チップ額、合計、一人当たりの負担額が分かります。`)
};

const zh_pct_tip_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费小费计算器。输入账单金额、小费比例和人数，查看小费金额、总额及人均分摊。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_meta_description", locale)
	if (locale === "en") return en_pct_tip_meta_description(inputs)
	if (locale === "es") return es_pct_tip_meta_description(inputs)
	if (locale === "de") return de_pct_tip_meta_description(inputs)
	if (locale === "nl") return nl_pct_tip_meta_description(inputs)
	if (locale === "fr") return fr_pct_tip_meta_description(inputs)
	if (locale === "it") return it_pct_tip_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_meta_description(inputs)
	if (locale === "pt") return pt_pct_tip_meta_description(inputs)
	if (locale === "ja") return ja_pct_tip_meta_description(inputs)
	return zh_pct_tip_meta_description(inputs)
};